/**
 * Generic DOM scroll utilities.
 */

const isScrollable = (el: HTMLElement): boolean => {
  const { overflowY } = getComputedStyle(el);
  return (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
};

/** Walks up the DOM from `el` and returns the first scrollable ancestor, or null. */
const findScrollableAncestor = (el: HTMLElement | null): HTMLElement | null => {
  const parent = el?.parentElement ?? null;
  if (!parent) return null;
  return isScrollable(parent) ? parent : findScrollableAncestor(parent);
};

/**
 * Scrolls the first scrollable ancestor of `from` to the top.
 * Useful when the scrollable container isn't known in advance — e.g. the same UI
 * may live inside different layouts where scrolling happens on different ancestors.
 */
export const scrollNearestScrollableToTop = (from: HTMLElement | null): void => {
  findScrollableAncestor(from)?.scrollTo({ top: 0, behavior: 'smooth' });
};
